import Vue from 'vue'
import { getLanguage } from '@/api/auth'
import { getAppUiText } from '@/utils/language/common'

const state = Vue.observable({
  tasks: [],
  visible: false,
  collapsed: false
})

function getUi(language) {
  return getAppUiText(language || getLanguage())
}

function getRunningCount() {
  return state.tasks.filter(task => task && task.state == 'running').length
}

function getSummary(language) {
  const ui = getUi(language)
  const total = state.tasks.length
  const running = getRunningCount()
  const failed = state.tasks.filter(task => task && task.state == 'error').length
  if (running > 0) {
    return `${running}/${total} ${ui.uploading}`
  }
  if (failed > 0) {
    return `${failed}/${total} ${ui.uploadFailed}`
  }
  return `${total}/${total} ${ui.uploadDone}`
}

function registerTaskHandlers(task, handlers = {}) {
  if (!task) {
    return task
  }
  Object.defineProperty(task, '__uploadHandlers', {
    value: Object.assign({}, handlers),
    configurable: true,
    enumerable: false,
    writable: true
  })
  return task
}

function addTask(task, handlers = {}) {
  if (!task) {
    return task
  }
  registerTaskHandlers(task, handlers)
  state.tasks.unshift(task)
  state.visible = true
  state.collapsed = false
  return task
}

function cancelTask(task) {
  if (!task) {
    return
  }
  Vue.set(task, 'cancelled', true)
  if (task.abortController && typeof task.abortController.abort == 'function') {
    task.abortController.abort()
  }
}

function removeTask(task) {
  if (!task) {
    return
  }
  cancelTask(task)
  state.tasks = state.tasks.filter(item => item && item.id != task.id)
  if (state.tasks.length == 0) {
    state.visible = false
    state.collapsed = false
  }
}

function closeList() {
  state.tasks.forEach(task => cancelTask(task))
  state.tasks = []
  state.visible = false
  state.collapsed = false
}

function retryTask(task) {
  if (!task || task.state != 'error') {
    return
  }
  const handlers = task.__uploadHandlers || {}
  if (typeof handlers.retry != 'function') {
    return
  }
  state.visible = true
  state.collapsed = false
  Vue.set(task, 'cancelled', false)
  Vue.set(task, 'abortController', null)
  Vue.set(task, 'state', 'running')
  Vue.set(task, 'progress', 0)
  Vue.set(task, 'statusText', getUi().uploading)
  handlers.retry(task)
}

export default {
  state,
  getRunningCount,
  getSummary,
  registerTaskHandlers,
  addTask,
  removeTask,
  closeList,
  retryTask
}
